import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/services/[slug]/components/ServiceDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ClientFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/PublicHeader.tsx");
